export class ApiError extends Error {
    status;
    code;
    details;
    /** Populated when the server replied with `{ message, errors: [...] }`
     *  — every bulk-import endpoint (users/parts/sites CSV import) uses
     *  this same flat shape for row-scoped validation failures. Callers
     *  used to reach for this via `.details`/`.data`/`.payload` — none of
     *  which exist on ApiError — which is why row errors from a bad CSV
     *  import silently never rendered. Read `.rowErrors` instead. */
    rowErrors;
    constructor(opts) {
        super(opts.message);
        this.name = 'ApiError';
        this.status = opts.status;
        this.code = opts.code;
        this.details = opts.details;
        this.rowErrors = opts.rowErrors;
    }
}
function extractRowErrors(body) {
    const raw = body?.errors;
    if (!Array.isArray(raw))
        return undefined;
    const rows = raw.filter((e) => !!e && typeof e === 'object' && typeof e.row === 'number' && typeof e.message === 'string');
    return rows.length > 0 ? rows : undefined;
}
export function normalizeAxiosError(err) {
    const ax = err;
    if (ax?.isAxiosError) {
        const status = ax.response?.status ?? 0;
        const body = ax.response?.data;
        // Preserve the full response body in `details` so callers can read
        // ad-hoc fields like `retry_after_seconds` from rate-limit (429)
        // responses without having to fish them out of axios manually.
        let details = body?.details;
        if (!details && body && typeof body === 'object') {
            details = { ...body };
        }
        return new ApiError({
            status,
            code: status ? `HTTP_${status}` : ax.code ?? 'NETWORK_ERROR',
            message: body?.message ?? ax.message ?? 'Request failed',
            details,
            rowErrors: extractRowErrors(body),
        });
    }
    if (err instanceof Error) {
        return new ApiError({ status: 0, code: 'UNKNOWN', message: err.message });
    }
    return new ApiError({ status: 0, code: 'UNKNOWN', message: 'Unknown error' });
}
//# sourceMappingURL=errors.js.map